import { UserService, AuthenticationError } from '@/services/userService'
import TokenService from '@/services/storageService'
import isObject from '@/utils/isObject'
import isObjectEmpty from '@/utils/isObjectEmpty'

const state = {
	authenticating: false,
	accessToken: TokenService.getToken(),
	authenticationErrorCode: 0,
	authenticationError: '',
	refreshTokenInterval: null,
	user: {},
	userPending: false
}

const getters = {
	user: (state) => state.user,
	isLoggedIn: (state) => state.accessToken ? true : false,
	authenticationErrorCode: (state) => state.authenticationErrorCode,
	authenticationError: (state) => state.authenticationError,
	authenticating: (state) => state.authenticating,
	userPending: (state) => state.userPending
}

const mutations = {
	saveUser(state, payload) {
		state.user = (isObject(payload) && !isObjectEmpty(payload))
			? payload
			: {}
	},

	userPending(state) {
		state.userPending = true
	},

	userComplete(state) {
		state.userPending = false
	},

	loginRequest(state) {
		state.authenticating = true
		state.authenticationError = ''
		state.authenticationErrorCode = 0
	},

	loginSuccess(state, accessToken) {
		state.accessToken = accessToken
		state.authenticating = false
	},

	loginError(state, { errorCode, errorMessage }) {
		state.authenticating = false
		state.authenticationErrorCode = errorCode
		state.authenticationError = errorMessage
	},

	logoutSuccess(state) {
		state.accessToken = ''
		state.user = {}
	},

	refreshTokenInterval(state, interval) {
		console.log('mutation: refreshTokenInterval...')
		state.refreshTokenInterval = interval
	}
}

const actions = {
	setAuth({ dispatch, commit }, user) {
		commit('saveUser', user)
		commit('loginSuccess', user.access_token)
		dispatch('setRefreshTokenInterval')
	},

	async login({ dispatch, commit }, { email, password }) {
		commit('loginRequest')
		try {
			const response = await UserService.login(email, password)
			dispatch('setAuth', response.data.user)
			return true
		} catch (e) {
			if (e instanceof AuthenticationError)
				commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
			return false
		}
	},

	async register({ dispatch, commit }, payload) {
		commit('loginRequest')
		try {
			const response = await UserService.register(payload)
			dispatch('setAuth', response.data.user)
			return true
		} catch (e) {
			if (e instanceof AuthenticationError)
				commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
			return false
		}
	},

	refreshToken() {
		UserService.refreshToken()
	},

	setRefreshTokenInterval() {
		UserService.setRefreshTokenInterval()
	},

	logout({ commit }) {
		UserService.logout()
		commit('logoutSuccess')
	},

	/**
	 * If user is logged in but no user object can be found,
	 * fetch user from database. Log out if unsuccessful.
	 */
	async getUser({ getters, commit, dispatch }) {
		// Exit if not logged in
		if (!getters.isLoggedIn) return
		// If user object is in memory, use that
		if (!isObjectEmpty(getters.user)) return getters.user
		// Otherwise begin fetching user
		commit('userPending')
		let response = await UserService.getUser()
		if (!response) dispatch('logout')
		else commit('saveUser', response.data.user)
		commit('userComplete')
	}
}

export default { namespaced: true, state, getters, actions, mutations }
